import { Navigate, Outlet, Route, Routes } from "react-router";
import { Link } from "react-router-dom";
import ToolsNavMenu from "../../components/tools/tools-nav-menu";
import Changelog from "./changelog";
import EarTraining from "./ear-training/ear-training";
import { changelog } from '../../config';

export default function ToolsIndex() {
  
    const currentVersionChangelog = changelog.releases[0];

    return (
      <div className="page tools">
        <div className="sidebar">
          <div className="branding-box">
            <h1>Bass Tools</h1>
          </div>
          <hr />
          <ToolsNavMenu />
          <div className="footer">
            <hr />
            <p><Link to="changelog" className="text-white text-decoration-none">v{currentVersionChangelog.version} - {currentVersionChangelog.date}</Link></p>
          </div>
        </div>
        <div className="main">
          <Routes>
              <Route path="" element={<Navigate replace to="ear-training" />} />
              <Route path="ear-training" element={<EarTraining />} />
              <Route path="changelog" element={<Changelog />} />
          </Routes>
          <Outlet />
        </div>
      </div>
    );
}